module.exports = __webpack_public_path__ + "static/arminvanbuuren_2-3c2d2d8079b4c68cb936de0027eb7382.jpg";